module.exports = __webpack_public_path__ + "productrating-complete.069f6b27.svg";